export default (country: any, hasAccessPointAddress = false) => {
  return (value: string) => {
    if (country === "Italy" && !hasAccessPointAddress) {
      return String(value ?? "").trim().length === 2;
    }
    return true;
  };
};
